import pako from 'pako';

const inflate = async (data: ArrayBuffer|Blob) => {
	const arrayBufferData = data instanceof Blob ? await data.arrayBuffer() : data;
	return JSON.parse(pako.inflate(arrayBufferData, { to: 'string' }));
}

export default inflate;